import React from 'react';
import Modal from '../Inc/Modal';
function PopAttendanceCheck(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_attendance_check">
      <h2 className="pop_tit line">출석 체크</h2>
      <div className="content_container scroll">
        {/* popup - type1 */}
        <select className="select">
          <option value="수업 연기">수업 연기</option>
          <option value="조퇴">조퇴</option>
        </select>
        <div className="notice">
          <p className="txt">
            <span className="dot" />
            체크일 : 2023.06.06 <span className="bar" />
            17:00
          </p>
          <p className="txt">
            <span className="dot" />
            포인트 : <span className="com_blue_txt">-10</span>
          </p>
        </div>
        <p className="alert_txt com_red_txt">* 미 출석체크는 포인트 감점 사유가 됩니다.</p>
        {/*<p className="alert_txt com_red_txt">* 이 수업은 ‘보고서’ 등록을 완료해야 출석체크가 인정이 됩니다.</p>*/}
        {/* popup - type2 */}
        <select className="select">
          <option value="수업 연기">수업 연기</option>
          <option value="조퇴">조퇴</option>
        </select>
        <section className="com_input_wrap flex_row">
          <input type="date" className="com_datepicker" />
          <select className="select">
            <option value="18시">18시</option>
          </select>
          <select className="select">
            <option value="30분">30분</option>
          </select>
        </section>
        <textarea className="textarea" placeholder="내용 입력 (50자)"></textarea>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopAttendanceCheck;
